import React, { useEffect } from 'react';
import {useLocation, useParams, useSearchParams} from 'react-router-dom';
import { useAppDispatch } from '../../../store/hooks';
import { queryParams } from "../../../helpers/UrlHelpers";
import { fetchBundles } from "../../../actions/watcher/bundlesActions";
import { setNewParams } from "../../../store/watcher/bundlesSlice";

import PageLayout from "src/pages/_partials/Layout/PageLayout";
import Edit from "./Edit";
import New from "./New";
import ListTable from "./_partials/_ListTable";
import PageHeader from "../../../componets/PageHeader";
import Wrapper from "../../../componets/Wrapper";
import Filter from "../../../componets/Filter";
import './style.scss';
import NavBarThree from "../../../componets/NavBarThree";
import { PlusOutlined } from "@ant-design/icons";

const LIMIT = 42;
const DEFAULT_ORDER_BY = 'prod';

const Bundles = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const currentPage = queryParams.getInt(searchParams,'page') || 1;
  const { pathname } = useLocation();
  const { app_id } = useParams();

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        app_id: app_id,
        limit:  LIMIT,
        offset: (currentPage - 1) * LIMIT,
        show_addons: true
      },
      ['term', 'order_by', 'order', 'date_from', 'date_to'],
      { 'order_by': DEFAULT_ORDER_BY }
    );

    dispatch(fetchBundles(params));
  }, [searchParams, app_id, pathname, currentPage, dispatch]);

  function onClickCreate() {
    const params: any = { app_id: app_id, prod: true, platform: 'ios' };
    dispatch(setNewParams(params));
  }

  return (
    <PageLayout className='v-bundles'>
      <PageHeader title='Bundles' />

      <Wrapper>
        <NavBarThree>
          <NavBarThree.Button className='v-link2' onClick={onClickCreate}>
            <PlusOutlined /> Create Bundle
          </NavBarThree.Button>
        </NavBarThree>
      </Wrapper>

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter
            search
            dateRange
            orderBy={{
              defaultKey: DEFAULT_ORDER_BY,
              items: [
                { name: 'Date', key: 'id' },
                { name: 'Version', key: 'version' },
                { name: 'Platform', key: 'platform' },
                { name: 'Name', key: 'name' },
              ]
            }}
          />
        </Wrapper>

        <ListTable limit={LIMIT} />
      </div>

      <New />
      <Edit />
    </PageLayout>
  );
}

export default Bundles;
